
<aside id="sidebar"
    class="lg:flex hidden top-0 left-0 z-20 flex flex-col flex-shrink-0 pt-16 h-full bg_color transition-all duration-200 ease-in-out"
    aria-label="Sidebar" [class]="isSidebarExpanded ? 'w-64' : 'w-20'">
    <div class="flex relative flex-col flex-1 pt-0 min-h-0 bg_color">
      <div class="px-2 flex overflow-y-auto flex-col flex-1 pt-7 pb-4 md:pt-5">
        <div class="card_color rounded-lg p-2 flex-1 bg_color" id="sidebar-items">
          <ul class="pb-2">
            <ul class="pb-2 text_white hidden lg:block flex items-center justify-between">
              <!-- Elemento de la lista con texto -->

              <button
                class="p-2 mr-1 flex items-center px-2.5 text-sm font-normal text_white hover:text_black rounded-lg group button_color_customize hover:button_color_customize transition-all duration-200 ml-auto"
                (click)="isSidebarExpanded = !isSidebarExpanded">
                <svg viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" class="h-6 w-6 transform"
                  [class]="isSidebarExpanded ? 'rotate-180' : 'rotate-0'">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <line x1="4" y1="6" x2="14" y2="6" />
                  <line x1="4" y1="18" x2="14" y2="18" />
                  <path d="M4 12h17l-3 -3m0 6l3 -3" />
                </svg>
              </button>
            </ul>

            <!-- Botón: Categoría 01 -->

            <li *ngFor="let category of model; let i = index" class="pb-2">
              <a [routerLink]="!category.disabled ? category.routerLink : null"
                class="flex items-center px-2.5 text-sm font-normal text_white hover:text_black rounded-lg group button_color_customize hover:button_color_customize transition-all duration-200 py-3"
                [class]="isSidebarExpanded ? 'py-3' : 'py-1'">
                <!-- Versión simplificada del SVG -->
                <span class="text-2xl text_color_customize group-hover:text_black transition-colors duration-300">
                  <app-menu-icons [iconLabel]="category.label"></app-menu-icons>
                </span>

                <span class="ml-2 font-medium" [class]="isSidebarExpanded ? 'opacity-100' : 'opacity-0'">{{ category.label }}</span>
              </a>
            </li>

          </ul>

          <!-- Redes sociales en sidebar -->
          <div class="divide_y_customize divide_color_customize"></div>
          <app-social-links [social_networks]="social_networks"></app-social-links>
          
        </div>
      </div>
    </div>
  </aside>